module.exports = __webpack_public_path__ + "img/block_3.9b2dcbf5.png";